import React from "react";
import { ArcStack } from "@src/core/ui";
import { SectionsProps } from "./types";
import { MissionSections } from "./Mission";
import { IdleSections } from "./Idle";
import { UpdateRequiredSections } from "./UpdateRequired";


export const Sections: React.FC<SectionsProps> = (props) => {
  const { idleDrones = [], missionDrones = [], updateRequiredDrones = [] } = props;

  return (
    <ArcStack spacing={4}>
      <MissionSections drones={missionDrones} />
      <IdleSections drones={idleDrones} />
      <UpdateRequiredSections drones={updateRequiredDrones} />
    </ArcStack>
  );
};
